/* eslint-disable */
//import jqueryGlobal from './jqueryGlobal.js';
//import * as bootstrap from 'bootstrap/dist/js/bootstrap.bundle';
//import { publicProfile, saveUserProfile, setActivePublicProfile, userProfile, savePublicProfile, activeOrg } from './profile.js';
//import { docReady } from '../utils.js';
//import { addDoc, collection, doc, getDoc, getDocs, orderBy, query, Timestamp, where } from 'firebase/firestore';
//import { app, db } from './firebaseInit.js';
//import Alpine from 'alpinejs';
//import { PublicProfile, Organization, OrgPublicProfile, BBEvent, BBScheduledEvent } from './models/index.js';
//import Inputmask from 'inputmask';
//import { initAppPub } from './appPub.js';
//import relativeTime from 'dayjs/plugin/relativeTime';
//import dayjs from 'dayjs';
import { bbterms } from './rodeoFloVariables.js';

function initPage() {
	$('#terms').html(bbterms);
}

initPage()

//docReady(addListeners);
//docReady(initPage);
